import axios from 'axios'
import library from '../../../utils/Library'

export const addGlobalNotificationEAuthz = async (body) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('global_notification') +
    '/addGlobalNotificationEAuthz'

  return await axios({
    url: URL,
    method: 'POST',
    data: body,
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
